
import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { Modal } from "antd";
import { ExpandAltOutlined } from "@ant-design/icons";
import { DefaultTitle } from "../defaultTitle";
import { ContainerSementes } from "./style";
import { Item__Atividades, ItemPropriedades } from "../../../../../../services/atividades/GET";
import { obterDadosSementes, obterDadosSementesCompletos } from "./meta";
import { TreemapChart } from "./components/treemapChart";
import { transition_default } from "../../../../../../utils";

//CONST
const segmento_permitido = ['', 'Todos', 'Sementes'];

interface Props {
    width?: string | number;
    todas_atividades_ativas: Item__Atividades[];
    data_propriedades: ItemPropriedades[];
    segmento: string;
}

export const SementesPorArea: React.FC<Props> = ({ width, todas_atividades_ativas, data_propriedades, segmento }) => {

    const { treemap: dadosTreemap, area_total } = obterDadosSementes(todas_atividades_ativas, data_propriedades);
    const { treemap: dadosCompletos } = obterDadosSementesCompletos(todas_atividades_ativas, data_propriedades);
    const [modalAberto, setModalAberto] = useState(false);

    return (
        <AnimatePresence>
            {segmento_permitido.includes(segmento) && (
                <ContainerSementes
                    layout
                    style={{ ...(width ? { width } : {}) }}
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ y: 90, opacity: 0, transition: { delay: 0, ease: [0, 0.71, 0.2, 1.01] } }}
                    transition={{ ...transition_default, delay: 0.6 }}
                    key={'sementes_por_area'}
                >
                    <DefaultTitle title="Sementes por Área" />
                    <ExpandAltOutlined
                        onClick={() => setModalAberto(true)}
                        style={{
                            fontSize: 14,
                            cursor: 'pointer',
                            color: '#999',
                            padding: 4,
                            borderRadius: 4,
                            transition: 'color 0.2s',
                            position: 'absolute',
                            right: 10,
                            top: 10
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.color = '#555')}
                        onMouseLeave={(e) => (e.currentTarget.style.color = '#999')}
                    />
                    <p className="ContainerSementes__total">Área total: {area_total} ha</p>

                    <div className="ContainerSementes__content">
                        <TreemapChart
                            data={dadosTreemap}
                            width={273}
                            is_empty={todas_atividades_ativas.length === 0}
                        />
                    </div>

                    <Modal
                        open={modalAberto}
                        onCancel={() => setModalAberto(false)}
                        footer={null}
                        title="Sementes por Área"
                        width={700}
                        centered
                    >
                        <p style={{ color: '#888', fontSize: 13, marginTop: -5, marginBottom: 10 }}>
                            Área total: {area_total} ha
                        </p>
                        <TreemapChart
                            data={dadosCompletos}
                            width={'100%'}
                            is_empty={todas_atividades_ativas.length === 0}
                        />
                    </Modal>
                </ContainerSementes>
            )}
        </AnimatePresence>
    );
}